// extracted by mini-css-extract-plugin
export default {"game_actions":"GameAction_game_actions__HXcZp","game_action_btn":"GameAction_game_action_btn__NxkxP"};